import { setCookieValue } from "@src/client/context/cookies";

const setNewBrowseCurrency = newCurrency => {
  setCookieValue("browseCurrency", newCurrency);
};

export default setNewBrowseCurrency;
